import React from 'react';
import styled from '@emotion/styled';
import FacebookIcon from '../../svg/FacebookIcon';
import InstagramIcon from '../../svg/InstagramIcon';
import LinkedinIcon from '../../svg/LinkedinIcon';
import YoutubeIcon from '../../svg/YoutubeIcon';
import TwitterIcon from '../../svg/TwitterIcon';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledFooterSocial = styled.div`
	h6 {
		font-size: 20px;
		line-height: 28px;
		letter-spacing: 0.15px;
		text-transform: uppercase;
		color: #ffffff;
		font-weight: bold;

		${EmotionBreakpoint('mobile')} {
			font-size: 16px;
			line-height: 24px;
		}
	}

	${EmotionBreakpoint('mobile')} {
		svg {
			width: 24px;
			height: 24px;
		}
	}
`;

function FooterSocial({ brandData }) {
	const Components = {
		facebook: FacebookIcon,
		instagram: InstagramIcon,
		youtube: YoutubeIcon,
		linkedin: LinkedinIcon,
		twitter: TwitterIcon,
	};
	return (
		<StyledFooterSocial className='align-items-center d-flex justify-content-start'>
			{brandData?.social.length > 0 && (
				<>
					<h6 className='mb-0 text-white'>Follow us on social media</h6>
					<div className='footer-v2__social__icons ml-24'>
						{brandData.social.map((social, index) => {
							let { name, url } = social;
							return (
								<a
									href={url}
									key={index}
									title={'Follow us on ' + name}
									target='_blank'
									rel='noreferrer'
									className='d-inline-block'
								>
									{React.createElement(Components[name])}
								</a>
							);
						})}
					</div>
				</>
			)}
		</StyledFooterSocial>
	);
}

export default FooterSocial;
